module.exports = __webpack_public_path__ + "static/media/jm_logo.a02eaf3e.png";